/* eslint-disable class-methods-use-this */
import React from 'react'
import { getReactComponentName } from '@lacele/utils'
import hoistNonReactStatic from 'hoist-non-react-statics'
import { generateStoreTarget } from '../utils'
import ReducerHolder from '../ReducerHolder'

export default (reducer, globalReducer) => (Component) => {

    class Hoc extends React.Component {

        constructor(props) {
            super(props)
            this.renderComponent = this.renderComponent.bind(this)
            this.renderReducerComponent = this.renderReducerComponent.bind(this)
        }

        renderComponent(props) {
            return <Component {...props} />
        }

        renderReducerComponent(disableReducerComponent, props) {
            if (disableReducerComponent) {
                return this.renderComponent(props)
            }
            return (
                <ReducerHolder
                    reducer={reducer}
                    globalReducer={globalReducer}
                    {...props}
                    render={this.renderComponent}
                />
            )
        }

        renderNoStoreTarget(disableReducerComponent, props) {
            const borderStyle = {
                border: '2px solid red'
            }
            const borderStyle2 = {
                border: '2px solid white'
            }
            const headerStyle = {
                borderBottom: '2px solid white',
                backgroundColor: 'red',
                color: 'white',
                fontWeight: 'bold'
            }
            return (
                <div style={borderStyle}>
                    <div style={borderStyle2}>
                        <div style={headerStyle}>storeTarget not set!</div>
                        <div>{this.renderReducerComponent(disableReducerComponent, props)}</div>
                    </div>
                </div>
            )
        }

        render() {
            const {
                disableReducerComponent,
                ...props
            } = this.props
            if (!props.storeTarget) {
                props.storeTarget = generateStoreTarget(this)
                if (console) {
                    (console.warn || console.log)(`storeTarget not set in ${getReactComponentName(Component)}`, this)
                }
                if (process.env.NODE_ENV === 'development') {
                    // return this.renderNoStoreTarget(disableReducerComponent, props)
                }
            }
            return this.renderReducerComponent(disableReducerComponent, props)
        }
    }

    Hoc.displayName = `withReducer(${getReactComponentName(Component)})`
    if (reducer) {
        Hoc.reducer = reducer
    }
    if (globalReducer) {
        Hoc.globalReducer = globalReducer
    }
    hoistNonReactStatic(Hoc, Component)
    return Hoc
}
